import { useContext, useEffect, useState } from 'react';

import { typesContext } from '../contexts';
import type { Package } from '~/shared/types';

export const usePackageSelectionLogic = (filter: number) => {
  const { types, isLoading } = useContext(typesContext);
  const [packages, setPackages] = useState<Package[]>([]);

  const categories = types.filter((type) => type.isSubscriptionEnabled);

  // logic for sorting and merging the packages

  useEffect(() => {
    const filteredPackages = types.map((type) => {
      if ((type.typeId === filter || !filter) && type.isSubscriptionEnabled) {
        return type.packages;
      }

      return [];
    });
    const flatPackages = filteredPackages.flat();
    setPackages(flatPackages);
  }, [filter, types]);

  return { packages, categories, isLoading };
};
